<template lang="pug">
  v-layout(row wrap)
    v-flex.header-acct(xs12)
      title-section(text="Addons")
        template(slot='icon')
          v-icon.mr-2(color="black") $vuetify.icons.addon

    v-flex.mt-4.mb-2(xs12)
      title-section(text="Available Add-Ons for your Subscription", type="subtitle")

    v-flex.ml-3.mb-5(xs12)
      v-layout(row wrap)
        v-flex(xs12)
        v-layout.ml-2.card-content(row, wrap)
          addon-card(:properties='addons.addons.landingPages')
            template(slot='icon')
              v-flex(xs2)
                v-icon(medium, color='black') menu_book
              v-flex(xs10)
                h2.title-addon Landing Pages

          addon-card(:properties="addons.addons.leadPlus")
            template.title-addon(slot='icon')
              v-flex(xs2)
                v-icon(medium, color='black') $vuetify.icons.leads-plus
              v-flex(xs10)
                h2.title-addon Leads+

          addon-card(:properties='addons.addons.multiLineDialer')
            template(slot='icon')
              v-flex(xs2)
                v-icon(medium, color='black') $vuetify.icons.phone-dial
              v-flex(xs10)
                h2.title-addon Multi Line Dialer
</template>
<script>
import TitleSection from './TitleSection';
import AddonCard from './AddonCard';
import { ADDONS } from '../config'

export default {
  name: 'Addons',
  components: {
    TitleSection,
    AddonCard,
  },
  data() {
    return {
      addons: ADDONS,
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn {
  color: var(--v-secondary-lighten3);
}
</style>
